import React from 'react';
import { V } from '../../common/Layout';
import type { ProductionTypeSuperset } from '../helpers/productionApi';
import DescriptionLabel from './DescriptionLabel';
import { ProductionAssociatedEntities } from './ProductionAssociatedEntities';
import ProjectOwner from './ProjectOwner';

type ProductionInfoAndOwnersProps = {
    workspace: ProductionTypeSuperset;
    setWorkspace?: React.Dispatch<React.SetStateAction<ProductionTypeSuperset>>;
    isReadOnly?: boolean;
    isSaving?: boolean;
};

const ProductionInfoAndOwners = ({ workspace, setWorkspace, isReadOnly, isSaving }: ProductionInfoAndOwnersProps) => {
    const { projectOwnerContacts, about } = workspace;

    return (
        <V gap={1.5}>
            <DescriptionLabel description={about} />
            <ProjectOwner projectOwners={projectOwnerContacts} />
            <ProductionAssociatedEntities
                workspace={workspace}
                setWorkspace={setWorkspace}
                isReadOnly={isReadOnly}
                isSaving={isSaving}
            />
        </V>
    );
};

export default ProductionInfoAndOwners;
